module.exports = __webpack_public_path__ + "static/media/onea.e8c64dbf.svg";